// import { API_FIELDS } from 'library/constants/models/barcode-item';
import * as constants from './constants';
import { FILTER_KEYS, SORT_DIRECTION as DIRECTIONS } from './fixtures';

// todo - consider move filters/query data to separate reducers
export const initialState = {
  loading: false,
  data: [],
  error: null,
  filters: {
    [FILTER_KEYS.PAGE]: 1,
    [FILTER_KEYS.PER_PAGE]: 20,
    [FILTER_KEYS.HAS_MORE]: false,
    [FILTER_KEYS.SORT_DIRECTION]: DIRECTIONS.NAME,
    // [FILTER_KEYS.TYPE]: 'item',
    // [FILTER_KEYS.QUANTITY]: null,
    [FILTER_KEYS.CATEGORIES]: [],
    [FILTER_KEYS.MANUFACTURERS]: [],
    // [FILTER_KEYS.STORAGE]: [],
    // [FILTER_KEYS.TAGS]: [],
    // [FILTER_KEYS.ITEMS]: [],
    [FILTER_KEYS.QUERY]: null,
  },
};
export const barcodeItemsReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
  case constants.GET_BARCODE_ITEMS:
    return {
      ...state,
      loading: true,
    };
  case constants.SET_BARCODE_ITEMS_FILTERS:
    return {
      ...state,
      data: [],
      filters: {
        ...(action.payload && Object.keys(action.payload).length !== 0 ? {
          ...state.filters,
          ...action.payload,
          [FILTER_KEYS.PAGE]: 1,
          [FILTER_KEYS.HAS_MORE]: false,
        } : JSON.parse(JSON.stringify(initialState.filters))),
      },
    };
  // case constants.SET_BARCODE_ITEMS_QUERY:
  //   return {
  //     ...state,
  //     query: {
  //       data: action.payload,
  //     },
  //   };
  case constants.GET_BARCODE_ITEMS_SUCCESS:
    return {
      ...state,
      loading: false,
      // eslint-disable-next-line max-len
      data: [...(action.payload.filters[FILTER_KEYS.PAGE] !== 1 ? state.data : []), ...action.payload.data],
      filters: {
        ...state.filters,
        ...action.payload.filters,
        /* eslint-disable-next-line max-len */
        // [FILTER_KEYS.CATEGORIES]: [...state.filters[FILTER_KEYS.CATEGORIES], ...(action.payload.filters[FILTER_KEYS.CATEGORIES] || [])],
        // eslint-disable-next-line max-len
        // [FILTER_KEYS.MANUFACTURERS]: [...state.filters[FILTER_KEYS.MANUFACTURERS], ...(action.payload.filters[FILTER_KEYS.MANUFACTURERS] || [])],
        // eslint-disable-next-line max-len
        // [FILTER_KEYS.STORAGE]: [...state.filters[FILTER_KEYS.STORAGE], ...(action.payload.filters[FILTER_KEYS.STORAGE] || [])],
      },
    };
  case constants.GET_BARCODE_ITEMS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.payload,
      filters: {
        ...state.filters,
        [FILTER_KEYS.HAS_MORE]: false,
      /* eslint-disable-next-line max-len */
      // [FILTER_KEYS.CATEGORIES]: [...state.filters[FILTER_KEYS.CATEGORIES], ...(action.payload.filters[FILTER_KEYS.CATEGORIES] || [])],
      // eslint-disable-next-line max-len
      // [FILTER_KEYS.MANUFACTURERS]: [...state.filters[FILTER_KEYS.MANUFACTURERS], ...(action.payload.filters[FILTER_KEYS.MANUFACTURERS] || [])],
      // eslint-disable-next-line max-len
      // [FILTER_KEYS.STORAGE]: [...state.filters[FILTER_KEYS.STORAGE], ...(action.payload.filters[FILTER_KEYS.STORAGE] || [])],
      },
    };
  case constants.RESET_BARCODE_ITEMS:
    return JSON.parse(JSON.stringify(initialState));
  default:
    return state;
  }
};

const initialActionState = {
  selectedIds: [],
  openedItemId: null,
  isValid: false,
  isValidating: false,
  isLoading: false,
  existingItems: [],
  searchValue: null,
};

export const barcodeItemsActionReducer = (state = initialActionState, action) => {
  switch (action.type) {
  case constants.SELECT_BARCODE_ITEM:
    return { ...state, selectedIds: [...state.selectedIds, action.payload.id] };
  case constants.DESELECT_BARCODE_ITEM:
    return { ...state, selectedIds: state.selectedIds.filter((id) => id !== action.payload.id) };
  case constants.VALIDATE_BARCODE_ITEM:
    return {
      ...state, isValidating: true, isValid: false, existingItems: [],
    };
  case constants.VALIDATE_BARCODE_ITEM_SUCCESS:
    return {
      ...state, isValidating: false, existingItems: action.payload, isValid: action.payload?.length === 0,
    };
  case constants.VALIDATE_BARCODE_ITEM_ERROR:
    return {
      ...state, isValidating: false, isValid: false, existingItems: [],
    };
  case constants.SEARCH_BARCODE_ITEM:
    return {
      ...state, isLoading: true,
    };
  case constants.SEARCH_BARCODE_ITEM_SUCCESS:
    return {
      ...state, isLoading: false, searchValue: action.payload,
    };
  case constants.SEARCH_BARCODE_ITEM_ERROR:
    return {
      ...state,
      isLoading: false,
      searchValue: null,
    };
  case constants.RESET_BARCODE_ITEMS_ACTIONS:
    return initialActionState;
  default:
    return state;
  }
};
